<!-- eslint-disable vue/multi-word-component-names -->
<template>
  <!--TODO Would be nice to allow some seller customization, branding, theming, etc.  -->
  <!--Might need to make this clientOnly with template #fallback-->
   
  <div v-if="pending || error">
    <p>Loading...</p>
    <div v-if="error">
      <p>Error Fetching Product:</p>
      <p>{{ error }}</p>
    </div>
  </div>
  <div
    v-if="product"
    class="card"
  >
    <div
      class="flex flex-col sm:flex-row"
    >
      <!--Left Side-->
      <div class="basis-2/5">
        <v-btn
          icon 
          color="primary-darken-2"
          variant="text"
          elevation="0"
          class="float-right mb-n15"
          :ripple="false"
        >
          <MakeAWishButton
            :id="useRoute().params.id"
            :item-image-src="product.images[0].src"
            :item-title="product.title"
            :item-price="product.variants[selectIndex].price"
            :item-ship-cost="product.variants[selectIndex].shipCost"
          />
        </v-btn>
        <!--Carousel-->
        <div class="">
          <v-responsive
            :aspect-ratio="1 / 1"
            class="border rounded-lg"
          >
            <v-carousel
              class="fill-height min-h-[300px]"
              hide-delimiter-background
              show-arrows="hover"
              color="primary"
            >
              <!-- <template #prev>
              <v-btn
                icon
                color="transparent"
                elevation="0"
                @click="imageDecrement(product)"
              >
                <v-icon
                  size="large"
                  color="secondary"
                >
                  mdi-chevron-left
                </v-icon>
              </v-btn>
            </template>
            <template #next>
              <v-btn
                icon
                color="transparent"
                elevation="0"
                @click="imageIncrement(product)"
              >
                <v-icon
                  size="large"
                  color="secondary"
                >
                  mdi-chevron-right
                </v-icon>
              </v-btn>
            </template> -->
              <v-carousel-item
                v-for="(img, i) in product.images"
                :key="i"
              >
                <NuxtPicture
                  quality="80"
                  loading="eager"
                  :preload="true"
                  :src="img.src"
                  :alt="'This is an image of the '+product.title+' product.  If you are hearing this right now.. we assume you are blind.  We are sorry about that.  We hope you enjoy our products, and can assure you they are all very cool/stylish/fashionable/trendy/etc.'"
                />
                <template #placeholder>
                  <div class="align-center justify-center fill-height flex">
                    <v-progress-circular
                      indeterminate
                      aria-label="Visual Loading"
                    />
                  </div>
                </template>
              </v-carousel-item>
            </v-carousel>
          </v-responsive>
        </div>
      </div>
          
      <!--Pop-Up Carousel--> 
      <!-- <v-dialog
        v-model="gallerydrawer"
        max-width="800"
        class=""
      >
        <v-carousel
          class="bg-surface"
          hide-delimiter-background
          hide-delimiters
          color="primary"
          delimiter-icon="mdi-circle-slice-8"
        >
          <template #prev>
            <v-btn
              icon
              color="transparent"
              elevation="0"
              @click="imageDecrement(product)"
            >
              <v-icon
                size="large"
                color="primary-darken-2"
              >
                mdi-chevron-left
              </v-icon>
            </v-btn>
          </template>
          <template #next>
            <v-btn
              icon
              color="transparent"
              elevation="0"
              @click="imageIncrement(product)"
            >
              <v-icon
                size="large"
                color="primary-darken-2"
              >
                mdi-chevron-right
              </v-icon>
            </v-btn>
          </template>
          <v-carousel-item
            @click="gallerydrawer = true"
          >
            <NuxtPicture
              fit="contain"
              quality="85"
              loading="lazy"
              :src="product.images[product.imageNum].src"
              :alt="'This is an image of the '+product.title+' product.  If you are hearing this right now.. we assume you are blind.  We are sorry about that.  We hope you enjoy our products, and can assure you they are all very cool/stylish/fashionable/trendy/etc.'"
              class="flex justify-center align-center"
            />
          </v-carousel-item>
        </v-carousel>
        <div class="flex flex-col align-center pt-1 justify-center w-100 bg-primary-darken-2">
          <p class="text-xl text-center ">
            {{ product.title }}
          </p>
          <div>
            <v-btn
              icon
              color="transparent"
              elevation="0"
            >
              <MakeAWishButton
                :id="useRoute().params.id"
                :item-image-src="product.images[0].src"
                :item-title="product.title"
                :item-price="product.variants[selectIndex].price"
                :item-ship-cost="product.variants[selectIndex].shipCost"
                class="mt-n1"
              />
            </v-btn>
            <LazyZMiniCart 
              :item-id="useRoute().params.id"
              :variant-id="product.variants[selectIndex].id"
            />
            <v-btn
              icon
              color="transparent"
              elevation="0"
              @click="gallerydrawer = false"
            >
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </div>
        </div>
      </v-dialog> -->

      <!--Right Side-->
      <div
        class="flex flex-col basis-3/5 align-center md:mx-4 mt-4 md:mt-0"
      >
        <div class="w-full">
          <h1>
            {{ product.title }}
          </h1>
          <v-select
            id="variantSelectBox"
            v-model="defaultSelected"
            label="Variant"
            :items="product.variants"
            item-title="title"
            :item-value="defaultSelectedTitle"
            variant="outlined"
            class="sm:w-3/4 mx-auto"
          >
            <template #item="{props,item}">
              <v-list-item
                v-bind="props"
                :subtitle="'$'+(item.raw.price)/100"
                @click="variantSelect(product,props.key)"
              />
            </template>
          </v-select>
        </div>
        <div class="sm:ml-3 flex flex-col text-center align-center justify-center">
          <p class="text-2xl font-bold">
            {{ formatter.format(product.variants[selectIndex].price/100) }}
          </p>
          <p class="text-sm">
            Shipping Cost: {{ formatter.format(product.variants[selectIndex].shipCost/100) }}
          </p>
          <p class="text-sm">
            Est. Handling Time: {{ product.variants[selectIndex].handlingTime }} {{ product.variants[selectIndex].handlingTimeUnit }}s
          </p>
          <br>
        </div>
        <div
          v-if="product.visible"
          class="mx-auto btn-wide h-[60px]"
        >
          <ZAddToCartButton
            :item-id="useRoute().params.id"
            :variant-id="product.variants[selectIndex].id"
            class="p-6" 
          />
        </div>
            
        <div v-else>
          PRODUCT NOT AVAILABLE
        </div>
        <div
          v-if="!showDescription"
          class="p-4 mt-4"
        >
          <p
            id="textarea"
            ref="desc"
            class="description-overflow text-justify mt-4 md:mt-0"
          >
            {{ product.description }}
          </p>
          <!--Only show button if text is greater than three lines-->
          <button
            v-if="descHeight==72"
            class="link link-primary mt-1"
            @click="showDescription=true"
          >
            Show More
          </button>
        </div>
      </div>
    </div>
    <div
      v-if="showDescription"
      class="bg-base-100 p-4 mt-4"
    >
      <p class="text-lg font-bold text-left">
        {{ product.title }} Description
      </p>
      <p
        class="text-justify"
      >
        {{ product.description }}
      </p>
      
      <button
        class="link link-primary mt-1"
        @click="showDescription=false"
      >
        Show Less
      </button>
    </div>
    <!--Reviews-->
    <div class="w-full">
      <Reviews />
    </div> 
  </div>
  
  <!-- Need a new component, RelatedProducts/ReccommendedProducts (subcollection of references to other product docs for each product) -->
</template>

<script setup>
import { doc } from 'firebase/firestore'
import { useDocument } from 'vuefire'
import { useElementSize } from '@vueuse/core'

// const gallerydrawer=ref()
const loaded = ref(false)
const imageNum = ref(0)
const imageIncrement = async () => {
  //Need to ensure the incremented image includes variant_ids  

  if(imageNum.value<product.value.images.length-1){
    imageNum.value++
  } else {
    imageNum.value = 0
  }
  while(!product.value.images[imageNum.value].variant_ids.includes(product.value.variants[selectIndex.value].id)){
    if(imageNum.value<product.value.images.length-1){
      imageNum.value++
    } else {
      imageNum.value = 0
    }
  }
}

const imageDecrement = async () => {
  if(imageNum.value>0){
    imageNum.value--
  }else{
    imageNum.value = product.value.images.length-1
  }
  while(!product.value.images[imageNum.value].variant_ids.includes(product.value.variants[selectIndex.value].id)){
    if(imageNum.value>0){
      imageNum.value--
    }else{
      imageNum.value = product.value.images.length-1
    }
  }
}

const defaultSelectedTitle = ref('')
const showDescription = ref(false)
// const longdescription = ref(false)



// Create our number formatter.
const formatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',

    // These options are needed to round to whole numbers if that's what you want.
    //minimumFractionDigits: 0, // (this suffices for whole numbers, but will print 2500.10 as $2,500.1)
    //maximumFractionDigits: 0, // (causes 2500.99 to be printed as $2,501)
});
const docRef = doc(useFirestore(),'products',useRoute().params.id)

const { data:product, pending, promise, error } = useDocument(docRef, {ssrKey:'product:'+useRoute().params.id})
const selectVariant = ref()
const selectIndex = ref(0)
const defaultSelected = ref()

const variantSelect = (product, variantIndex) => {
  selectVariant.value = product.variants[variantIndex]
  selectIndex.value = variantIndex
  //Update image to ensure it includes only {variantId} images
  while(!product.images[imageNum.value].variant_ids.includes(product.variants[variantIndex].id)){
    imageNum.value++
  }
}

// const docData = ref({title:'Loading',description:'Loading...',images:[{src:''}]})

promise.value.then((v)=>{
  defaultSelected.value = v.variants[0]
  defaultSelectedTitle.value = v.variants[0].title
  selectVariant.value = v.variants[0]
  // docData.value = v
})

const desc = ref()
const { height:descHeight } = useElementSize(desc)

onMounted(()=>{

  useSeoMeta({
    title: ()=> `${useRuntimeConfig().public.SHOP_NAME} - ${product.value.title}`,
    ogTitle: ()=> `${useRuntimeConfig().public.SHOP_NAME} - ${product.value.title}`,
    description: ()=> `${product.value.description}`,
    ogDescription: 'Ever shop here?  A new US-Based eCommerce site with great prices on cute products.  They even do custom prints by request on tons of different products!',
    ogImage: ()=> `${product.value.images[0].src}`,
    twitterCard: 'summary_large_image',
    ogType:'website'
    // ogUrl:()=>`ogUrl:${useRoute().fullPath}`
  })

})



</script>

<style scoped>
.description-overflow { 
    display: -webkit-box; 
    -webkit-box-orient: vertical; 
    -webkit-line-clamp: 3; 
    overflow: hidden; 
    text-overflow: ellipsis; 
  } 
</style>